/**
 * * V1 (1.0) - The metadata is of the type `InstanceMetadata`( Deprecated since cod-dicomweb-server@v1.3.18 ).
 * * V2 (2.0) - The metadata is of the type `string`.
 */
export const METADATA_VERSION = {
  V1: '1.0',
  V2: '2.0'
};
